<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('leads_category')">
      <button class="btn btn-primary" @click="openModal">Add Category</button>
    </app-page-top-section>

    <div class="mb-3">
      <input
        type="text"
        v-model="search"
        @input="fetchCategories"
        placeholder="Search by title"
        class="form-control"
      />
    </div>

    <table class="table table-bordered">
      <thead>
      <tr>
        <th>#</th>
        <th>Title</th>
        <th>Details</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(cat,index) in categories.data" :key="cat.id">
        <td>{{ (categories.current_page - 1) * 10 + index + 1 }}</td>
        <td>{{ cat.title }}</td>
        <td>{{ cat.details || '-' }}</td>
        <td>
          <button class="btn btn-sm btn-primary" @click="editCategory(cat)">Edit</button>
          <button class="btn btn-sm btn-danger" @click="deleteCategory(cat.id)">Delete</button>
        </td>
      </tr>
      </tbody>
    </table>

    <nav v-if="categories.last_page > 1">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: categories.current_page === 1 }" @click="changePage(categories.current_page - 1)">
          <a class="page-link" href="#">Previous</a>
        </li>
        <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: categories.current_page === page }" @click="changePage(page)">
          <a class="page-link" href="#">{{ page }}</a>
        </li>
        <li class="page-item" :class="{ disabled: categories.current_page === categories.last_page }" @click="changePage(categories.current_page + 1)">
          <a class="page-link" href="#">Next</a>
        </li>
      </ul>
    </nav>

    <lead-category-form-modal
      v-if="isModalActive"
      v-model="isModalActive"
      :category="selectedCategory"
      @saved="fetchCategories"
    />
  </div>
</template>

<script>
import LeadCategoryFormModal from './Components/LeadCategoryFormModal.vue'

export default {
  name: 'AppLeadCategories',
  components: { LeadCategoryFormModal },
  data() {
    return {
      categories: { data: [], current_page: 1, last_page: 1 },
      isModalActive: false,
      selectedCategory: null,
      search: ''
    }
  },
  mounted() {
    this.fetchCategories()
  },
  computed: {
    totalPages() {
      const pages = []
      for (let i = 1; i <= this.categories.last_page; i++) {
        pages.push(i)
      }
      return pages
    }
  },
  methods: {
    fetchCategories(page = 1) {
      axios.get('/lead-categories', {
        params: {
          search: this.search,
          per_page: 10,
          page: page
        }
      }).then(res => { this.categories = res.data })
    },
    changePage(page) {
      if (page < 1 || page > this.categories.last_page) return
      this.fetchCategories(page)
    },
    openModal() {
      this.selectedCategory = null
      this.isModalActive = true
    },
    editCategory(cat) {
      this.selectedCategory = cat
      this.isModalActive = true
    },
    deleteCategory(id) {
      if (confirm('Are you sure?')) {
        axios.delete(`/lead-categories/${id}`).then(() => {
          this.fetchCategories(this.categories.current_page)
          alert('Deleted successfully!')
        })
      }
    }
  }
}
</script>

<style>
.pagination .page-item.disabled .page-link {
  pointer-events: none;
  opacity: 0.5;
}
.pagination .page-item.active .page-link {
  background-color: #0d6efd;
  border-color: #0d6efd;
  color: #fff;
}
</style>


